<template>
  <div class="bind">
    <h3>Vehicle : {{ vehicle_plate }}</h3>
    <el-row>
      <el-col :span="5">
        <el-form ref="leftForm" label-width="80px" class="gatewayForm">
         
        </el-form>
      </el-col>
      <el-col :span="19">
        <el-row>
          <el-col :span="10">
            <el-form ref="headLeftForm" :inline="true" class="form-inline head-left-inline" label-width="80px">
              
              <el-row v-for="(row, index) in leftRows" :key="index" :class="`row-${index+1}`">
                <el-col v-for="(item, index) in row" :key="item" :span="12">
                  <el-form-item :label="item.replace(/_/g, '-')" :style="{ opacity: tyreTemp[item] && tyreTemp[item].sensor ? 1 : 0}">
                    <el-input v-model="tyreTemp[item] && tyreTemp[item].value" :class="{'alert': tyreTemp[item] && isOutOfRange(tyreTemp[item].value)}">
                      <template slot="append">Bar</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            
          </el-col>
          <el-col :span="4">
            <div class="car">
              <div class="row row-1">
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_L_1_1) ? 1 : 0}">
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_L_1_2) ? 0.6 : 0}">
                <div class="space"></div>
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_R_1_1) ? 0.6 : 0}">
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_R_1_2) ? 1 : 0}">
              </div>
              <div class="row row-2">
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_L_2_1) ? 1 : 0}">
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_L_2_2) ? 0.6 : 0}">
                <div class="space"></div>
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_R_2_1) ? 0.6 : 0}">
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_R_2_2) ? 1 : 0}">
              </div>
              <div class="row row-3">
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_L_3_1) ? 1 : 0}">
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_L_3_2) ? 0.6 : 0}">
                <div class="space"></div>
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_R_3_1) ? 0.6 : 0}">
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_R_3_2) ? 1 : 0}">
              </div>
              <div class="row row-4">
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_L_4_1) ? 1 : 0}">
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_L_4_2) ? 0.6 : 0}">
                <div class="space"></div>
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_R_4_1) ? 0.6 : 0}">
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_R_4_2) ? 1 : 0}">
              </div>
              <div class="row row-5">
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_L_5_1) ? 1 : 0}">
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_L_5_2) ? 0.6 : 0}">
                <div class="space"></div>
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_R_5_1) ? 0.6 : 0}">
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_R_5_2) ? 1 : 0}">
              </div>
              <div class="row row-6">
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_L_6_1) ? 1 : 0}">
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_L_6_2) ? 0.6 : 0}">
                <div class="space"></div>
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_R_6_1) ? 0.6 : 0}">
                <img src="~assets/img/tire.png" :style="{ opacity: hasTypeTempObj(tyreTemp.H_R_6_2) ? 1 : 0}">
              </div>
              
              
            </div>
        </el-col>
          <el-col :span="10">
            <el-form ref="headRightForm" :inline="true" class="form-inline head-right-inline"  label-width="80px">
              <el-row v-for="(row, index) in rightRows" :key="index" :class="`row-${index+1}`">
                <el-col v-for="(item, index) in row" :key="item" :span="12">
                  <el-form-item :label="item.replace(/_/g, '-')" :style="{ opacity: tyreTemp[item] && tyreTemp[item].sensor ? 1 : 0}">
                    <el-input 
                       v-if="item in tyreTemp"
                      v-model="tyreTemp[item] && tyreTemp[item].value" 
                      :class="{'alert': tyreTemp[item] && isOutOfRange(tyreTemp[item].value)}">
                      <template slot="append">Bar</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
      </el-col>
      
    </el-row>
  </div>
</template>

<script>
  import { getVehicleByID } from "network/vehicle";

  export default {
    name: "DetailTrailer",
    data() {
      return {
        leftRows: [
          ['H_L_1_1', 'H_L_1_2'],
          ['H_L_2_1', 'H_L_2_2'],
          ['H_L_3_1', 'H_L_3_2'],
          ['H_L_4_1', 'H_L_4_2'],
          ['H_L_5_1', 'H_L_5_2'],
          ['H_L_6_1', 'H_L_6_2']
        ],
        rightRows: [
          ['H_R_1_1', 'H_R_1_2'],
          ['H_R_2_1', 'H_R_2_2'],
          ['H_R_3_1', 'H_R_3_2'],
          ['H_R_4_1', 'H_R_4_2'],
          ['H_R_5_1', 'H_R_5_2'],
          ['H_R_6_1', 'H_R_6_2']
        ],
        vehicle_plate: "",
        vehicle_id: "",
        gateway: "",
        tyreTemp: {}
      }
    },
    created() {
      this.vehicle_plate = this.$route.query.plate
      this.vehicle_id = this.$route.query.vehicle_id
    },
    mounted() {
      this.getVehicleDetail(this.vehicle_id)
    },
    methods: {
      getVehicleDetail(id) {
        getVehicleByID(id)
          .then((data) => {
            const rawData = data.data
            this.tyreTemp = rawData.tyre_pressure_dic
          })
          .catch((err) => {
            this.$message.error("Interface error:get_trailer_detail");
          });
      },
      isOutOfRange(value) {
        return value > 0 && value < 6
      },
      hasTypeTempObj(obj) {
        return obj && obj.sensor
      }
    }
  }
</script>

<style scoped>
.bind h3 {
  margin-bottom: 20px;
  font-size: 22px;
  font-weight: 400;
  color: #1f2f3d;
}
.bind .gatewayForm{
  margin-top: 70px;
}
.bind .head-left-inline {
  text-align: right;
}
.bind .head-right-inline {
  text-align: left;
}
.bind .form-inline .el-input {
  width: 140px;
  font-size: 16px;
}
::v-deep.bind .alert .el-input__inner{
  color: red;
}
::v-deep.bind .alert .el-input-group__append{
  color: red;
}
.bind .form-inline .row-1{
  margin-top: 70px;
}
.bind .form-inline .row-2{
  margin-top: 26px;
}
.bind .form-inline .row-3{
  margin-top: 0px;
}
.bind .form-inline .row-4{
  margin-top: 44px;
}
.bind .form-inline .row-5{
  margin-top: 4px;
}
.bind .form-inline .row-6{
  margin-top: 4px;
}
.bind .car{
  position: relative;
  width: 100%;
  height: 560px;
  background: url("~assets/img/bg_car_trail.png") no-repeat center;
}
.bind .car .row {
  display: flex;
  justify-content: center;
  text-align: center;
  line-height: 64px;
}
.bind .car .row-1{
  position: absolute;
  top: 10%;
  left: 0;
  right: 0;
}
.bind .car .row-2{
  position: absolute;
  top: 26%;
  left: 0;
  right: 0;
}
.bind .car .row-3{
  position: absolute;
  top: 38%;
  left: 0;
  right: 0;
}
.bind .car .row-4{
  position: absolute;
  top: 56%;
  left: 0;
  right: 0;
}
.bind .car .row-5{
  position: absolute;
  top: 68%;
  left: 0;
  right: 0;
}
.bind .car .row-6{
  position: absolute;
  top: 80%;
  left: 0;
  right: 0;
}

.bind .car .space{
  display: inline-block;
  width: 62px;
}
.bind .submitBtn{
  margin-top: 50px;
}
</style>